(window as any).__zone_symbol__UNPATCHED_EVENTS = ['message'];

/*
(window as any).__Zone_disable_requestAnimationFrame = true;
(window as any).__Zone_disable_timers = true;
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'resize', 'mousemove'];
*/
